import React from "react"
import ForgetPassword from "../components/ForgetPassword/ForgetPassword"

const ForgetPasswordView = () => <ForgetPassword />

export default ForgetPasswordView
